import {
  onBeforeUnmount,
  ref,
} from 'vue'
import prettyConsoleLog from 'src/utils/prettyConsoleLog'

const isPrintedError = ref(false)
const targetAttributeNames = new Set<string>()

function useYandexGoals({ targetAttributeName }: {
  targetAttributeName?: string,
} = {}) {
  if (process.env.IS_SERVER) {
    return { sendYaGoal: (_name: string) => {} }
  }

  if (!document.querySelector('#script-yandex-metrics')) {
    if (!process.env.IS_PROD && !isPrintedError.value) {
      isPrintedError.value = true
      prettyConsoleLog({
        module: 'YandexGoals',
        title: 'Error: ',
        message: 'На странице не установлен код счётчика Яндекс.Метрики',
      })
    }

    return {
      sendYaGoal: (_name: string) => {
        prettyConsoleLog({
          module: 'YandexGoals',
          title: 'Цель (мок):',
          message: _name,
        })
      },
    }
  }

  const isLoadedYandexScript = ref(Boolean(window.ym))
  const yaCounterId = window.YA_COUNTER_ID || ''

  const sendYaGoal = (name: string) => {
    if (!name || !isLoadedYandexScript.value) {
      return
    }

    if (process.env.IS_PROD) {
      window?.ym(yaCounterId, 'reachGoal', name)
    } else {
      prettyConsoleLog({
        module: 'YandexGoals',
        title: 'Цель:',
        message: name,
      })
    }
  }

  if (!isLoadedYandexScript.value) {
    /* see: https://yandex.ru/support/metrica/code/counter-initialize.html#counter-initialize__check-initialize */
    document.addEventListener(`yacounter${yaCounterId}inited`, () => {
      isLoadedYandexScript.value = true // сработает только в том случае, если на момент создания экземпляра не был загружен скрипт метрики
    })
  }

  if (targetAttributeName) {
    if (!targetAttributeNames.size) {
      document.addEventListener('click', event => {
        const target = event.target as HTMLElement | null

        /* Особенности кроссбраузерности FireFox */
        if (!target || !target.closest || !targetAttributeNames.size) {
          return
        }

        targetAttributeNames.forEach(attribute => {
          const goalName = target.closest(`[${attribute}]`)
            ?.getAttribute(attribute)

          if (goalName) {
            sendYaGoal(goalName)
          }
        })
      })
    }

    targetAttributeNames.add(targetAttributeName)
  }

  onBeforeUnmount(() => {
    if (targetAttributeName) {
      targetAttributeNames.delete(targetAttributeName)
    }
  })

  return { sendYaGoal }
}

export default useYandexGoals
